import styled from "styled-components";

export const MapControlsShrinkButton = styled("div")`
  height: 20px;
  width: 20px;
  background-image: url("/Images/MobileInsights/minimize.svg");
  cursor: pointer;
`;

export const MapControlsExpandButton = styled("div")`
  background: #fff;
  height: 48px;
  width: 48px;
  border-radius: 50%;
  background-image: url("/Images/MobileInsights/sliders.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  box-shadow: -1px 2px 21px -10px rgba(49, 49, 49, 1);
`;

export const MapCenterButton = styled("div")`
  background: #fff;
  height: 48px;
  width: 48px;
  border-radius: 50%;
  background-image: url("/Images/MobileInsights/center-icon.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  box-shadow: -1px 2px 21px -10px rgba(49, 49, 49, 1);
`;

export const GPSBenchmarkButton = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  max-width: 184px;
  border: 1px solid #d3dfdc;
  opacity: 50%;
  cursor: pointer;

  &.gps-benchmark-button-selected {
    background-color: #434a54;
    color: #fff;
    border: 0;
    opacity: 100%;
  }

  &.gps-benchmark-button-leftmost {
    border-radius: 4px 0 0 4px;
    border-right: 1px solid #d3dfdc;
  }

  &.gps-benchmark-button-rightmost {
    border-radius: 0 4px 4px 0;
  }

  &.gps-benchmark-button-middle {
    border-radius: 0;
    border-right: 1px solid #d3dfdc;
  }
`;

export const GPSBenchmarkButtonEllipsis = styled("span")`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 1em;
  line-height: 1.2em;
`;
